import {
  ADMIN,
  ADMIN_FR,
  DRIVER,
  DRIVER_FR,
  FLEET_MANAGER,
  FMC,
  FMC_FLEET_ADMIN,
  FMC_FLEET_ADMIN_FR,
  FMC_FLEET_MANAGER,
  FMC_FLEET_MANAGER_FR,
  FMC_FR,
  FMC_VIEW_ONLY,
  MANAGER,
  MANAGER_FR,
  OWNER,
  OWNER_FR,
  SUPER_ADMIN,
  SUPER_ADMIN_FR
} from "../constants/roles"
import { ADMIN_ROLE_NAMES } from "./activeMaintenanceHelpers"

export function selectOptions(userRoles) {
  let options = []

  userRoles.forEach((role) => {
    options.push({
      label: role.name,
      value: role.name
    })
  })

  return options
}

export function isFMCUser(user) {
  return (
    user &&
    user.roles &&
    user.roles.find(
      (role) =>
        role === FMC ||
        role.name === FMC ||
        role === FMC_FLEET_ADMIN ||
        role.name === FMC_FLEET_ADMIN ||
        role === FMC_FLEET_MANAGER ||
        role.name === FMC_FLEET_MANAGER ||
        role === FMC_VIEW_ONLY ||
        role.name === FMC_VIEW_ONLY
    )
  )
}

export function isFMC(user) {
  return user && user.roles && user.roles.find((role) => role === FMC || role.name === FMC)
}

export function isDriver(user) {
  return user && user.roles && user.roles.length === 1 && user.roles.includes(DRIVER, DRIVER_FR)
}

export const EXCLUDED_ROLES = [
  FMC,
  FMC_FLEET_MANAGER,
  FMC_FLEET_ADMIN,
  FMC_FLEET_ADMIN_FR,
  FMC_FLEET_MANAGER_FR,
  FMC_FR
]

export const FLEET_ADMIN_ROLES = [
  OWNER,
  OWNER_FR,
  MANAGER,
  MANAGER_FR,
  ADMIN,
  ADMIN_FR,
  FMC,
  FMC_FR,
  SUPER_ADMIN,
  SUPER_ADMIN_FR,
  FMC_FLEET_ADMIN,
  FMC_FLEET_ADMIN_FR,
  FMC_FLEET_MANAGER,
  FMC_FLEET_MANAGER_FR,
  FLEET_MANAGER
]

export function canAddEditFMCUser(user) {
  return user && user.roles && user.roles.includes(FMC)
}

export function canAddNewFleet(user) {
  return user && user.roles && user.roles.find((role) => role === FMC || role === FMC_FLEET_ADMIN)
}

export function canAddVehicle(user) {
  if (user == null || user.roles == null) return false

  return (
    user.roles.find((role) => {
      return ADMIN_ROLE_NAMES.includes(role) || ADMIN_ROLE_NAMES.includes(role.name)
    }) != null
  )
}

export function canScheduleService(user) {
  return !(user && user.roles && user.roles.length === 1 && user.roles.includes(FMC_VIEW_ONLY))
}
